import createReducer from '../createReducer'
import { RELOAD_AUTH_SUCCESS } from 'services/auth/constants'
import { UPDATE_USER_SUCCESS } from './constants'

export const initialState = {
  display_measurement_system: 'metric',
  preferred_language: 'en-us',
}

export default createReducer(initialState, {

  [RELOAD_AUTH_SUCCESS]: (state, action) => {
    const { user: { data: user }} = action.payload
    return { ...state, ...user }
  },

  [UPDATE_USER_SUCCESS]: (state, action) => {
    return { ...state, ...action.payload.data }
  },

})
